import { Tooltip } from 'antd'
import type { FC } from 'react'
import styled from 'styled-components'

import type { TicketLlmStatsResult } from './computeTicketLlmStats'

const ACCEPTED_COLOR = '#52c41a'
const EDITED_COLOR = '#faad14'
const REJECTED_COLOR = '#ff4d4f'

const WITH_AI_TOOLTIP =
  'Tickets where at least one field has LLM lineage (llmValue set)'

export const SummaryCards: FC<{ stats: TicketLlmStatsResult }> = ({
  stats,
}) => {
  const { totalTickets, ticketsWithLlm, fieldTotals } = stats
  const withLlmPct =
    totalTickets === 0 ? 0 : Math.round((ticketsWithLlm / totalTickets) * 100)

  return (
    <SummaryRow>
      <SummaryCard>
        <SummaryValue>{totalTickets}</SummaryValue>
        <SummaryLabel>Total Tickets</SummaryLabel>
      </SummaryCard>

      <Tooltip title={WITH_AI_TOOLTIP}>
        <SummaryCard>
          <SummaryValue>{ticketsWithLlm}</SummaryValue>
          <SummaryLabel>With AI</SummaryLabel>
          <SummarySubtext>{withLlmPct}% of total</SummarySubtext>
        </SummaryCard>
      </Tooltip>

      <SummaryCard>
        <SummaryValue $color={ACCEPTED_COLOR}>
          {fieldTotals.accepted}
        </SummaryValue>
        <SummaryLabel>Accepted Fields</SummaryLabel>
      </SummaryCard>

      <SummaryCard>
        <SummaryValue $color={EDITED_COLOR}>{fieldTotals.edited}</SummaryValue>
        <SummaryLabel>Edited Fields</SummaryLabel>
      </SummaryCard>

      <SummaryCard>
        <SummaryValue $color={REJECTED_COLOR}>
          {fieldTotals.rejected}
        </SummaryValue>
        <SummaryLabel>Rejected Fields</SummaryLabel>
      </SummaryCard>
    </SummaryRow>
  )
}

const SummaryRow = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
`

const SummaryCard = styled.div`
  flex: 1;
  min-width: 140px;
  background: ${({ theme }) => theme.colors.gray[800]};
  border: 1px solid ${({ theme }) => theme.forecast.border};
  border-radius: 8px;
  padding: 1rem 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`

const SummaryValue = styled.div<{ $color?: string }>`
  font-size: 2rem;
  font-weight: 700;
  line-height: 1;
  color: ${({ $color, theme }) => $color ?? theme.forecast.activeText};
`

const SummaryLabel = styled.div`
  font-size: 0.8125rem;
  color: ${({ theme }) => theme.forecast.defaultText};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`

const SummarySubtext = styled.div`
  font-size: 0.75rem;
  color: ${({ theme }) => theme.forecast.defaultText};
`
